import { Component, Input, OnChanges } from '@angular/core';
import { SmAssignableBadgeVM } from "../sm-assignable-badge/sm-assignable-badge.viewmodel";
import type { AuroraAvatarUserInterface } from '@insurity/aurora-lit';

export type SmAvatarColor = 'signal' | 'vapor' | 'arctic' | 'charge';

@Component({
    standalone: false,
    selector: 'sm-avatar',
    templateUrl: './sm-avatar.component.html',
    styleUrls: ['./sm-avatar.component.scss']
})
export class SmAvatarComponent implements OnChanges {
    @Input() model: SmAssignableBadgeVM;
    @Input() color: SmAvatarColor;
    @Input() image: string;
    @Input() state: 'enabled' | 'disabled' | 'pending' = 'enabled';
    @Input() size: 'small' | 'medium' | 'large' | 'xlarge' = 'medium';

    // null puts aurora-avatar into its pending state (dashed "?").
    public auroraUser: AuroraAvatarUserInterface | null = null;
    public auroraColor: SmAvatarColor;

    ngOnChanges() {
        this.auroraColor = this.color ?? this.defaultColor();
        this.auroraUser = !this.model || this.state === 'pending' ? null : {
            initials: this.model.Initials,
            name: this.model.Name,
            subline1: this.model.Title,
            subline2: '',
            disabled: !!this.model.Disabled || this.state === 'disabled',
            image: this.image ?? ''
        };
    }

    private defaultColor(): SmAvatarColor {
        if (this.model?.IsCurrentUser) {
            return 'signal';
        }
        return this.model?.Initials && this.model.Initials !== '?' ? 'charge' : 'vapor';
    }
}